<template>
	<div id='video-box' class="cover" @click='playOrPause' :style='fullscreenVideoStyle'>
		<video @click.prevent ref='video' class="video" 
			:src="src" 
			@pause='onpause' 
			@playing='onplaying' 
			@timeupdate='ontimeupdate' 
			@canplay='canplay' 
			@ended='onEnded' 
			@progress='onprogress'
			@volumechange='onvolumechange'
			@webkitendfullscreen="webkitendfullscreen"
			:style='fullscreenVideoStyle'
			x5-video-player-type="h5"
            webkit-playsinline=""
            playsinline=""
		></video>
		<div class="tool" :style='fullscreenToolStyle'>
			<div class="buttons" @click.stop>
				<div class="left">
					<div class="button s-play" @click='playOrPause'>
						<img v-if='isPlaying' src="@/assets/pause.png">
						<img v-else src="@/assets/splay.png">
					</div>
					<div class="times">{{currentTime | format}}/{{duration|format}}</div>
				</div>
				<div class="right">
					<div class="button voice" @click='mutedOrNot'>
						<div class="voice-bar" @click.stop.prevent='changeVoice'>
							<div ref='voiceBar' class="chart" >
								<div class="volume" :style='{height:volumePercent}'></div>
							</div>
						</div>
						<img v-if='isMuted' src="@/assets/muted.png">
						<img v-else src="@/assets/voice.png">
					</div>
					<div class="button fullscreen" @click='openFullscreen'><img src="@/assets/fullscreen.png"></div>
				</div>
			</div>
			<div class="progress" @click.stop='seek' ref='progress'>
				<div class="cacheed" :style='{width:cacheedPercent}'></div>
				<div class="played" :style='{width:playedPercent}'></div>
			</div>
		</div>
		<img :src="pic" v-if='pic && !isPlaying && currentTime == 0' class="cover-img">
		<img v-if='!isPlaying && canPlay' src="@/assets/play.png" class="play button">
	</div>
</template>

<script>
import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				isPlaying:false,
				currentTime:0,
				canPlay:false,
				duration:0,
				isFullscreen:false,
				bufferedDuration:0,
				volume:1,
				isMuted:false,
			}
		},
		props:{
			src:{
				type:String,
				default:'',
			},
			seekable:{
				type:Boolean,
				default:false,
			},
			pic:{
				type:String,
				default:'',
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		filters:{
			format(value){
				if(value < 0)return '00:00'
				let hour = parseInt(value / 3600)
				let minute = parseInt((value - hour * 3600) / 60)
				let second = parseInt(value - hour * 3600 - minute * 60)
				if(hour)return `${hour > 9?hour:'0'+hour}:${minute > 9 ? minute:'0'+minute}:${second > 9 ? second : '0'+second}`
				return `${minute > 9 ? minute:'0'+minute}:${second > 9 ? second :'0'+second}`
			},
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
			cacheedPercent(){
				if (this.duration == 0) return 0
				let percent = (this.bufferedDuration / this.duration) * 100 + '%'
				return percent
			},
			playedPercent(){
				if (this.duration == 0) return 0
				let percent = (this.currentTime / this.duration) * 100 + '%'
				return percent
			},
			volumePercent(){
				if (this.isMuted) return 0;
				let percent = this.volume * 100 + '%'
				return percent
			},
			fullscreenVideoStyle(){
				if (this.isFullscreen) {
					return {
						width:"100vw !important",
						height:"100vh !important",
						maxHeight:'100vh',
					}
				}
			},
			fullscreenToolStyle(){
				if (this.isFullscreen) {
					return {
						width:"100vw",
						bottom:0,
					}
				}
			}

		},
		methods: {
			...mapActions([
				
			]),
			async initData(){
				document.addEventListener("fullscreenchange",()=>{
					this.isFullscreen = document.fullscreen
				})
				document.addEventListener("mozfullscreenchange",()=>{
					this.isFullscreen = document.mozFullScreen
				})
				document.addEventListener("webkitfullscreenchange",()=>{
					this.isFullscreen = document.webkitIsFullScreen
				})
				document.addEventListener("msfullscreenchange",()=>{
					this.isFullscreen = document.msFullscreenElement
				})
			},
			canplay(e){
				this.canPlay=true
				this.duration = e.target.duration
				this.getBuffered(e.target)
			},
			onEnded(e){
				this.$emit('onPlayEnded',e)
				this.exitFullScreen();
			},
			onprogress(e){
				this.getBuffered(e.target)
			},
			onvolumechange(e){
				this.volume = e.target.volume
			},
			getBuffered(video){
				let duration = video.duration
				if (duration > 0) {
	                for (var i = 0; i < video.buffered.length; i++) {
	                    // 寻找当前时间之后最近的点
	                    let bufferedStart = video.buffered.start(video.buffered.length - 1 - i),
	                    	bufferedEnd = video.buffered.end(video.buffered.length - 1 - i)
	                    if (bufferedStart <= video.currentTime) {
	                        this.bufferedDuration = bufferedEnd
	                        break;
	                    }
	                }
	            }
			},
			ontimeupdate(e){
				let currentTime = e.target.currentTime
				if (!this.seekable) {
					document.activeElement.blur()
					if (currentTime - this.currentTime > 1) {
						e.target.currentTime = this.currentTime
					} else {
						this.currentTime = currentTime
					}
				} else {
					this.currentTime = currentTime
				}
			},
			onpause(e){
				this.isPlaying = false
				if (!this.seekable) {
					document.activeElement.blur()
				}
				this.$emit('onPause',e)
			},
			onplaying(e){
				this.isPlaying = true
				let currentTime = e.target.currentTime
				if (!this.seekable) {
					if (currentTime - this.currentTime > 1) {
						e.target.currentTime = this.currentTime
					} else {
						this.currentTime = currentTime
					}
					document.activeElement.blur()
				} else {
					this.currentTime = currentTime
				}
				this.$emit('onPlaying',e)
				
			},
			playOrPause(){
				if (this.isPlaying) {
					this.$refs.video.pause()
				} else {
					this.$refs.video.play()
				}
			},
			changeVoice(e){
				let rect = this.$refs.voiceBar.getBoundingClientRect()
				this.$refs.video.volume = 1 - (e.clientY - rect.y)/rect.height
			},
			mutedOrNot(){
				this.$refs.video.muted = !this.$refs.video.muted
				this.isMuted = this.$refs.video.muted
			},
			seek(e){
				if (!this.seekable) return
				let rect = this.$refs.progress.getBoundingClientRect()
				let seekTo = (e.clientX - rect.x)/rect.width * this.duration
				this.$refs.video.currentTime = seekTo
		    },
			openFullscreen() {
				if (this.isFullscreen) {
					this.exitFullScreen()
					return
				}
				let el = document.getElementById('video-box')
		        if (el.requestFullscreen) {
		            el.requestFullscreen();
		        } else if (el.mozRequestFullScreen) {
		            el.mozRequestFullScreen();
		            this.$refs.video.mozRequestFullScreen();
		        } else if (el.msRequestFullscreen) {
		            el.msRequestFullscreen();
		        } else if (el.webkitRequestFullscreen) {
		            el.webkitRequestFullScreen();
		        } else {
					let el = this.$refs.video
					el.pause()
					el.playsInline = false
					el.play()
				}
		    },
    		exitFullScreen() {
		        if (document.exitFullscreen) {
		            document.exitFullscreen();
		        } else if (document.mozCancelFullScreen) {
		            document.mozCancelFullScreen();
		        } else if (document.msExitFullscreen) {
		            document.msExiFullscreen();
		        } else if (document.webkitCancelFullScreen) {
		            document.webkitCancelFullScreen();

		        } else if (document.webkitExitFullscreen) {
		            document.webkitExitFullscreen();
		        }
		    },
			webkitendfullscreen() {
				let el = this.$refs.video
				el.playsInline = true
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.cover {
		height:45vw;
		display: flex;
		justify-content: center;
		align-items: center;
		position:relative;
		// cursor: pointer;
		.video {
			width:100%;
			height:100%;
			background-color: #272821;
			outline: none;
		}
		.cover-img {
			left: 0;
			top: 0;
			width: 100%;
			height:100%;
			position: absolute;
		}
		.play {
			position:absolute;
			width:100px;
			height:100px;
			left:calc(50% - 50px);
			top:calc(50% - 50px);
			// left: calc()
			border-radius: 50px;
		}
	}
	.tool {
		display:flex;
		flex-direction: column;
		position: absolute;
		left: 0;
		padding: 5px 15px;
		height:60px;
		width: 100%;
		bottom: 0;
		background-color: rgba(0,0,0,0.3);
		// display:none;
		.buttons {
			display:flex;
			justify-content: space-between;
			align-items: center;
			.left,.right {
				display:flex;
				align-items: center;
			}
			.times {
				color: white;
				@include fontSize($font-size-16);
			}
			.button {
				width: 30px;
				height:30px;
				margin-right: 10px;
				cursor: pointer;
				// background-color: red;
				display:flex;
				align-items: center;
				justify-content: center;
				img {
					width: 20px;
					display:block;
				}
			}
			.voice {
				position: relative;
				&:hover {
					.voice-bar {
						display:flex;
					}
				}
				.voice-bar {
					position: absolute;
					bottom: 30px;
					width: 100%;
					height:100px;
					padding-top: 10px;
					background-color: rgba(0,0,0,0.5);
					display:none;
					align-items: center;
					justify-content: center;
					.chart {
						position: relative;
						height:100%;
						width: 5px;
						background-color: #B2B1B2;
						border-radius: 20px;
						.volume {
							border-radius: 20px;
							width: 100%;
							position: absolute;
							bottom:0;
							background-color: #fff;
						}
					}
				}
			}
		}
		
		.progress {
			height:5px;
			margin-top: 5px;
			border-radius: 20px;
			background-color: #5a5755;
			position: relative;
			cursor: pointer;
			.played {
				position: absolute;
				// width: 100px;
				height:5px;
				border-radius: 20px;
				background-color: #fff;
			}
			.cacheed {
				border-radius: 20px;
				position: absolute;
				// width: 200px;
				height:5px;
				background-color: #B2B1B2;
			}
		}
	}
	@media (max-width: 768px){
		.cover {
			.play {
				width:50px;
				height:50px;
				left:calc(50% - 25px);
				top:calc(50% - 25px);
			}
		}
	}
</style>